import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'warning-svg',
  templateUrl: './warning.component.html',
  styleUrls: ['./../../../svg.scss']
})
export class WarningSvgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
